import * as React from 'react';
import withClickOutsideOnOverlay from '../../../../hoc/withClickOutsideOnOverlay';
import BasicFormWithValidation from '../../../forms/BasicFormWithValidation';
import { FormWithCancelButton, FormWithCancelButtonProps } from '../../../forms/FormWithCancelButton';
import { validateScriptName } from '../../../../services/validations/validateScriptName';
import { getScriptTypeLabel } from '../../../../services/mini/getScriptTypeLabel';
import { IProject } from '../../../../models/IProject';
import { IScript } from '../../../../models/IScript';
import { IDuplicateScriptParam } from '../../../../redux/projects/actions.projects';
import { nextDuplicatedScriptName } from '../../../../services/mini/nextDuplicatedScriptName';

interface DuplicateScriptFormProps extends FormWithCancelButtonProps {
    project: IProject;
    script: IScript;
    scriptName: string;
    transformsAvailable: boolean
    duplicateScript: (p: IDuplicateScriptParam) => void;
}

class DuplicateScriptForm extends FormWithCancelButton<DuplicateScriptFormProps> {
    validateScriptName = ({ scriptName: newScriptName }) => {
        const { project, scriptName, transformsAvailable } = this.props;

        if (newScriptName === scriptName) {
            return null;
        }

        return validateScriptName(newScriptName, project, transformsAvailable ? 'Script or transform' : undefined);
    }

    ok = ({ scriptName }) => {
        const { project, script } = this.props;
        const existingScriptName = this.props.scriptName;

        if (scriptName === existingScriptName) {
            this.cancel();
        } else {
            this.props.duplicateScript({
                projectId: project.projectId,
                tagId: project.stageTagId,
                script,
                scriptName,
            });
            this.props.onClose();
        }
    }

    render() {
        const { scriptName, script, project } = this.props;

        return <BasicFormWithValidation
            title={`Duplicate ${getScriptTypeLabel(script)}`}
            type="rename"
            hasCloseIcon={true}
            enableActionBtnByDefault={true}
            className="rename-script-form"
            inputs={[{
                name: 'scriptName',
                label: `${getScriptTypeLabel(script)} name`,
                autoFocus: true,
                maxLength: 50,
                maxLengthMsg: `Max{${getScriptTypeLabel(script).toLowerCase()} length: 50 characters`,
                value: nextDuplicatedScriptName(scriptName, project.scripts),
                rules: [this.validateScriptName],
                applyOnEnter: true
            }]}
            okButton={{
                label: 'Duplicate',
                action: this.ok
            }}
            cancelButton={{
                label: 'Cancel',
                action: this.cancel,
            }}
        />;
    }
}

export default withClickOutsideOnOverlay(DuplicateScriptForm);